
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trucking-companies/[slug]",
      function () {
        return require("private-next-pages/trucking-companies/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trucking-companies/[slug]"])
      });
    }
  